import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dmzj4e52w6: FaireBrandEntity = {
  token: "b_dmzj4e52w6",
  type: "brand",
  name: "AAJewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/340430688e50980f5cb3923ff31050439f2cc94d8901837ba1a56b3cf57eea02.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/85fd989b4e29e17546dc7f53d7374d09f0b217eac9a00aedf136ced0443b8d5c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/340430688e50980f5cb3923ff31050439f2cc94d8901837ba1a56b3cf57eea02.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/85fd989b4e29e17546dc7f53d7374d09f0b217eac9a00aedf136ced0443b8d5c.png",
  location: "Richmond, BC, CAN",
  minimumOrderDollars: 139,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "ARC & AURA combines modern design with timeless elegance. Drawing inspiration from the harmony of natural forms and the unique energy of each individual, Arc & Aura offers a collection of meticulously crafted pieces that reflect both strength and grace. With a focus on minimalist aesthetics and refined craftsmanship, the brand’s designs feature subtle arcs and radiant accents, symbolizing balance, transformation, and beauty. Whether you’re seeking an everyday piece or a statement accessory, Arc & Aura creates jewelry that enhances your inner glow and complements your personal style.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:31.379Z",
    importedBy: "entity-db-cli",
  },
};
